{
  "title": "حسابي",
  "subtitle": "بيانات الدخول: البريد الإلكتروني وكلمة المرور",
  "profile": {
    "title": "الملف الشخصي",
    "email": "البريد الإلكتروني",
    "emailHint": "يُرسل رمز تأكيد إلى البريد الجديد، ويصل إشعار إلى بريدك الحالي بعد التغيير."
  },
  "email": {
    "title": "تغيير البريد الإلكتروني",
    "current": "البريد الحالي:",
    "newEmail": "البريد الإلكتروني الجديد",
    "currentPassword": "كلمة المرور الحالية",
    "currentPasswordHint": "للتأكد أنك صاحب الحساب",
    "passwordRequired": "أدخل كلمة المرور الحالية",
    "invalid": "أدخل بريداً إلكترونياً صحيحاً",
    "sendCode": "إرسال الرمز",
    "sending": "جارٍ الإرسال…",
    "codeSentSelf": "أدخل الرمز المكوّن من 6 أرقام المرسل إلى {{email}}",
    "codeSentOther": "اطلب من صاحب الحساب الرمز المكوّن من 6 أرقام المرسل إلى {{email}} ثم أدخله هنا",
    "codeLabel": "رمز التأكيد",
    "validFor": "الرمز صالح لمدة 10 دقائق",
    "wrongCode": "الرمز غير صحيح. المحاولات المتبقية: {{n}}",
    "expired": "انتهت صلاحية الرمز أو استُنفدت المحاولات. ابدأ من جديد.",
    "startOver": "البدء من جديد",
    "changeAddress": "تغيير البريد المُدخل",
    "resend": "إعادة إرسال الرمز",
    "resendIn": "إعادة الإرسال بعد {{n}} ث",
    "resent": "تم إرسال رمز جديد",
    "changed": "تم تغيير البريد الإلكتروني إلى {{email}}"
  },
  "password": {
    "title": "تغيير كلمة المرور",
    "current": "كلمة المرور الحالية",
    "currentRequired": "أدخل كلمة المرور الحالية",
    "new": "كلمة المرور الجديدة",
    "confirm": "تأكيد كلمة المرور الجديدة",
    "notEmail": "يجب ألا تطابق كلمة المرور البريد الإلكتروني",
    "otherDevices": "سيتم تسجيل خروجك من الأجهزة الأخرى، ويبقى هذا الجهاز متصلاً.",
    "submit": "تغيير كلمة المرور",
    "saving": "جارٍ الحفظ…",
    "changed": "تم تغيير كلمة المرور، وتم تسجيل الخروج من الأجهزة الأخرى"
  }
}
